import TrailCard from '@alltrails/cards/components/TrailCard';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import clickFromSection from '../../../utils/PageUI/clickFromSection';
import type { PageUITrailResultSection } from '../../../utils/PageUI/pageUI';
import trailFromPageUISection from '../../../utils/PageUI/trailFromPageUISection';
import { usePageUIActions } from '../PageUIActionContext/PageUIActionContext';
import { usePageUIMapHover } from '../PageUIMapHoverContext/PageUIMapHoverContext';
import { type PageUISaveableItem, usePageUISave } from '../PageUISaveContext/PageUISaveContext';
import styles from './PageUITrailResult.module.scss';

type Props = {
  /** The section's position in the PageUI result list */
  index: number;
  section: PageUITrailResultSection;
};

export default function PageUITrailResult({ index, section }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const { onSectionHover, onSectionHoverEnd } = usePageUIMapHover();
  const actions = usePageUIActions();
  const save = usePageUISave();
  const click = clickFromSection(section, index);
  const saveableItem: PageUISaveableItem = { type: 'trail', id: section.trailId };

  return (
    <TrailCard
      blockNavigation={Boolean(actions)}
      className={styles.trailResult}
      isCompleted={save?.isCompleted(saveableItem)}
      isFavorite={save?.isSaved(saveableItem)}
      isVerified={save?.isVerified(saveableItem)}
      languageRegionCode={languageRegionCode}
      onCardClick={actions && (event => actions.onClick(click, event))}
      onCardMouseEnter={() => onSectionHover(section)}
      onCardMouseLeave={onSectionHoverEnd}
      onFavoriteClick={save && (() => save.onSaveClick(saveableItem))}
      openInNewTab={!actions}
      trail={trailFromPageUISection(section)}
      url={actions?.getHref(click.clickAction)}
      variant="small"
    />
  );
}
